<template>
  <div id="line_chart" style="width: 100%;height:90%"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'lineChart',
  data: function () {
    return {
      chart: null,
      option: {
        grid: {
          left: 10,
          right: 20,
          bottom: 50,
          top: 120,
          containLabel: true
        },
        title: {
          text: '暂无数据',
          show: false,
          left: 'center',
          top: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          position: function (pt) {
            return [pt[0], 130]
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true, // true 留空  false 顶头
          data: [],
          show: true,
          axisTick: {
            show: false, // 是否展示刻度
            length: 5, // 刻度长度
            alignWithLabel: true // 刻度是否对齐 True 对齐
          },
          axisLabel: {
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          show: true
        },
        series: [{
          data: [],
          type: 'bar',
          barWidth: 5// 柱图宽度
          // showAllSymbol: true
        }]
      }
    }
  },
  props: {
    data: {
      type: Array
    }
  },
  watch: {
    data: {
      handler (value) {
        const xData = []
        const yData = []
        if (value && value.length > 0) {
          value.forEach(ele => {
            if (ele.name.length > 4) ele.name = ele.name.substring(0, 2)
            xData.push(ele.name)
            yData.push(ele.value)
          })
          this.option.xAxis.data = xData
          this.option.title.show = false
          this.option.xAxis.show = true
          this.option.yAxis.show = true
          this.option.series[0].data = yData
        } else {
          this.option.xAxis.data = xData
          this.option.title.show = true
          this.option.xAxis.show = false
          this.option.yAxis.show = false
          this.option.series[0].data = yData
        }
        this.$nextTick(() => {
          this.drawLinechart()
        })
      },
      immediate: true
    }
  },
  mounted () {

  },
  methods: {
    drawLinechart () {
      this.chart = echarts.init(document.getElementById('line_chart'))
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style scoped>
#chart2{
  /*border: 1px solid lightgray;*/
}
</style>
